/**
 * Plain helpers shared by the Documents sidebar's pieces: sort order, drag-id
 * parsing and the per-section synthetic drop-target ids. No React here.
 */

export const KEY_STEP = 1_000_000;
export const PERSONAL_SCOPE = { type: 'personal' };
// Free plan, cloud/local items: documents kept on this computer only.
export const DEVICE_SCOPE = { type: 'device' };

export function cmpNodes(a, b) {
  if (a.sortKey !== b.sortKey) return a.sortKey < b.sortKey ? -1 : 1;
  return (a.name || '').localeCompare(b.name || '');
}

export function parseDragId(dragId) {
  const i = dragId.indexOf('-');
  return { type: dragId.slice(0, i), id: dragId.slice(i + 1) };
}

// Unique-per-section root drop-target ids (see TreeSection's
// useSidebarDrag/onDragEnd) — plain node drag ids stay unprefixed
// (`folder-<id>` / `document-<id>`, unchanged from before sections existed)
// because useSidebarDrag's shared kind-detection keys off the `folder-`/
// `document-` prefix for drop-position math; cross-section rejection instead
// relies on each section's own `nodeById` map never containing a foreign
// section's node id (see onDragEnd in useTreeDnd.js). Only these two synthetic
// "root of the tree" targets need a section tag, since a bare `root-end`/
// `root-empty` string would otherwise collide across sections.
export function rootEndDragId(sectionId) {
  return `root-end::${sectionId}`;
}
export function rootEmptyDragId(sectionId) {
  return `root-empty::${sectionId}`;
}
